export const CSRF_NAME = "csrfmiddlewaretoken";
export const MAX_IMAGE_DIM = 1500;
export const IMAGE_UPDATE_EVENT_TYPE = "IMAGE_UPDATES";
export var SyncStatusState;
(function (SyncStatusState) {
    SyncStatusState["idle"] = "IDLE";
    SyncStatusState["syncing"] = "SYNCING";
    SyncStatusState["success"] = "SUCCESS";
    SyncStatusState["error"] = "ERROR";
})(SyncStatusState || (SyncStatusState = {}));
export const SYNC_EVENT_TYPE = "SYNC";
export const SYNC_ITEM_CREATED_EVENT_TYPE = "SYNC_ITEM_CREATED";
export const SYNC_ITEM_CHANGED_EVENT_TYPE = "SYNC_ITEM_CHANGED";
export const SYNC_ITEM_REMOVED_EVENT_TYPE = "SYNC_ITEM_REMOVED";
export const SYNC_ITEM_ERROR_EVENT_TYPE = "SYNC_ITEM_ERROR";
export const CSRF_TOKEN_EVENT_TYPE = "CSRF_TOKEN";
export const SYNC_ITEM_TIMEOUT_SECONDS = 60 * 3;
//# sourceMappingURL=constants.js.map